var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 44 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.123 5.40632L10.2285 5.41121C10.7506 5.46407 11.1582 5.90546 11.1582 6.44148C11.1582 7.01308 10.6946 7.4766 10.123 7.47664H4.9209C3.76292 7.47675 2.82048 8.41926 2.82031 9.57722V12.753C2.82031 16.8149 6.12501 20.1202 10.1865 20.1202H10.5684C11.14 20.1202 11.6035 20.5837 11.6035 21.1553C11.6035 21.727 11.14 22.1905 10.5684 22.1905H10.1865C4.98279 22.1905 0.75 17.9567 0.75 12.753V9.57722L0.755859 9.36335C0.867687 7.16224 2.69257 5.40649 4.9209 5.40632H10.123Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.0375 5.40632C41.3377 5.40647 43.2082 7.27716 43.2084 9.57722V12.753C43.2084 17.9566 38.9755 22.1905 33.7719 22.1905H33.39C32.8184 22.1905 32.3549 21.7269 32.3549 21.1553C32.3549 20.5837 32.8184 20.1202 33.39 20.1202H33.7719C37.8334 20.1202 41.1381 16.8149 41.1381 12.753V9.57722C41.1379 8.41928 40.1954 7.47678 39.0375 7.47664H33.8353C33.2637 7.47664 32.8002 7.01311 32.8002 6.44148C32.8002 5.86985 33.2637 5.40632 33.8353 5.40632H39.0375Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.7328 27.9876C25.3043 27.9877 25.7679 28.4512 25.7679 29.0228V39.1517C25.7678 39.7231 25.3043 40.1868 24.7328 40.1868H18.7181C18.1466 40.1868 17.6831 39.7231 17.683 39.1517V29.0228C17.683 28.4511 18.1465 27.9876 18.7181 27.9876C19.2898 27.9876 19.7533 28.4511 19.7533 29.0228V38.1165H23.6976V29.0228C23.6976 28.4511 24.1611 27.9876 24.7328 27.9876Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.3905 0.75C33.962 0.75013 34.4256 1.21361 34.4256 1.78516V17.75C34.4256 24.7529 28.7284 30.4492 21.7254 30.4492C14.7227 30.449 9.02621 24.7528 9.02621 17.75V1.78516L9.03109 1.67969C9.08392 1.15756 9.52532 0.75 10.0614 0.75H33.3905ZM11.0965 17.75C11.0965 23.6106 15.8649 28.3787 21.7254 28.3789C27.5861 28.3789 32.3553 23.6107 32.3553 17.75V2.82031H11.0965V17.75Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.7416 0.75L36.8471 0.754883C37.3691 0.807836 37.7767 1.24921 37.7767 1.78516C37.7767 2.35667 37.3132 2.82017 36.7416 2.82031H6.70936C6.13773 2.82031 5.6742 2.35678 5.6742 1.78516C5.6742 1.21353 6.13773 0.75 6.70936 0.75H36.7416Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.5163 38.1159C31.221 38.116 35.0484 41.9434 35.0486 46.6481V47.6705C35.0483 49.783 33.3298 51.5006 31.2175 51.5006H12.2331C10.1166 51.5006 8.39436 49.7794 8.39428 47.6627V46.6559C8.39442 41.9465 12.225 38.116 16.9343 38.1159H26.5163ZM16.9343 40.1862C13.3672 40.1863 10.4647 43.0888 10.4646 46.6559V47.6627C10.4647 48.6372 11.2583 49.4303 12.2331 49.4303H31.2175C32.1877 49.4303 32.9781 48.6407 32.9783 47.6705V46.6491C32.9783 43.086 30.0789 40.1863 26.5163 40.1862H16.9343Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.7301 8.7658C24.504 8.7658 26.7594 11.0265 26.7594 13.8049C26.7593 16.5782 24.5035 18.8342 21.7301 18.8342C18.9524 18.834 16.6921 16.5786 16.692 13.8049C16.692 11.0262 18.9518 8.76598 21.7301 8.7658ZM21.7301 10.8361C20.094 10.8363 18.7623 12.1683 18.7623 13.8049C18.7624 15.4352 20.0934 16.7637 21.7301 16.7638C23.3613 16.7638 24.689 15.4361 24.6891 13.8049C24.6891 12.1675 23.3606 10.8361 21.7301 10.8361Z",
    fill: "var(--fill-0, #1F1F1F)",
    stroke: "var(--stroke-0, #1F1F1F)",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon2);
export default __webpack_public_path__ + "static/media/group-icon-2.68851200e904d0a3f32bccb50bd78623.svg";
export { ForwardRef as ReactComponent };